import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { countFinishedStories } from "../../data/storiesProgressRepo";
import { FiBookOpen } from "react-icons/fi";
import "./StoryProgress.css";

export default function StoryProgress() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const language = "de"; // TEMP

  useEffect(() => {
    if (!user?.uid) return;

    let cancelled = false;

    async function run() {
      try {
        const n = await countFinishedStories({ uid: user.uid, language });
        if (!cancelled) setCount(n);
      } catch (err) {
        console.error("Error counting finished stories:", err);
        if (!cancelled) setCount(0);
      }
    }

    run();

    return () => {
      cancelled = true;
    };
  }, [user?.uid, language]);

  return (
    <div className="story-progress-card">
      <div className="story-progress-header">
        <FiBookOpen className="story-progress-icon" />
        <span className="story-progress-number">
          {count}
          <span className="story-progress-label">Histórias lidas</span>
        </span>
      </div>
    </div>
  );
}
